<template>
  <v-menu
    id="main-navigation-menu"
    offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        id="main-navigation-menu-activator"
        class="plain"
        v-on="on"
        text>
        <h4>{{selectedNavigation}}</h4>
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="route in permittedRoutes"
        :key="route.text"
        @click="$router.push(route);"
        :disabled="route.disabled">
        <v-list-item-title>{{ route.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'MainNavigationMenu',
  data() {
    return {
      routes: [
        {
          text: 'Call Log',
          name: 'CallLogPage',
          nameMatches: ['CallLogPage', 'CallLogNewPage'],
          requiresPermissions: ['CallsGetAll'],
        },
        {
          text: 'Customers',
          name: 'CustomersTablePage',
          nameMatches: ['CustomersTablePage', 'CustomerFormPage', 'CustomerFormNewPage'],
          requiresPermissions: ['CustomersGetAll'],
        },
        {
          text: 'Users',
          name: 'UsersTablePage',
          nameMatches: ['UsersTablePage', 'UserFormPage', 'UserFormNewPage'],
          requiresPermissions: ['UsersGetAll'],
        },
        {
          text: 'Administrator Settings',
          name: 'AdminPage',
          nameMatches: 'AdminPage',
          requiresPermissions: [
            // Codes Creation Tab
            'CallStatusCreate',
            'CallTypesCreate',
            'CustomerTypesCreate',
            'EmployeeTitlesCreate',
            'SoftwareTypesCreate',
            'PurchasingVendorsCreate',

            // Transaction History Tab
            'HistoryGetAll',
          ],
        },
        {
          text: 'Report Page',
          name: 'ReportPage',
          nameMatches: 'ReportPage',
        },
      ],
    };
  },
  computed: {
    selectedNavigation() {
      return _.find(
        this.routes,
        (route) => route.nameMatches.includes(this.$route.name),
      ).text;
    },
    permittedRoutes() {
      return _.filter(
        this.routes,
        (route) => this.isPermittedAtLeastOne(route.requiresPermissions),
      );
    },
  },
};
</script>

<style lang="scss">
#main-navigation-menu-activator {
  h4 {
    font-size: 20px !important;
  }
}
</style>
